import { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'next/link';

const Breadcrumb = ({ className, children, ...props }) => (
  <nav className={classNames('breadcrumb', className)} {...props}>
    <ol
      className="breadcrumb__list"
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      {Children.map(children, (child, index) => (
        isValidElement(child)
          ? cloneElement(child, { position: index + 1 })
          : child
      ))}
    </ol>
  </nav>
);

Breadcrumb.Item = ({ className, href, position, active, children, ...props }) => (
  <li
    className={classNames('breadcrumb__item', className)}
    itemScope
    itemType="https://schema.org/ListItem"
    itemProp="itemListElement"
    aria-current={active && 'page'}
    {...props}
  >
    {active ? (
      <a className="breadcrumb__link" itemProp="item" aria-current="location">
        <span itemProp="name">
          {children}
        </span>
      </a>
    ) : (
      <Link href={href}>
        <a className="breadcrumb__link" itemProp="item">
          <span itemProp="name" >
            {children}
          </span>
        </a>
      </Link>
    )}
    {!!position && (
      <meta itemProp="position" content={position} />
    )}
  </li>
);

Breadcrumb.Item.displayName = 'Breadcrumb.Item';

Breadcrumb.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Breadcrumb.Item.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  position: PropTypes.number,
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Breadcrumb;
